module.exports = __webpack_public_path__ + "static/media/nuonic-logo.2b4355f1.svg";